import {
    WaitingDaysStackedBarChart,
    WaitingDaysStackedBarChartProps
} from '../../renderers/waiting-days-stacked-bar-chart/waiting-days-stacked-bar-chart.component';

export const TransactionTimerWaitingDaysStackedBarChart = (props: WaitingDaysStackedBarChartProps) => <WaitingDaysStackedBarChart {...props} />;
